module.exports = __webpack_public_path__ + "media/images/emblems/Greng-coat_of_arms-58ebe2d29c5abfd3b7d58f608c6b3660.svg";